/* eslint-disable react-hooks/exhaustive-deps */
import { OrderStatusEnum } from 'common/enums';
import formatDate from 'common/helpers/formatDate';
import { useActions } from 'common/hooks/useActions';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { ReactSVG } from 'react-svg';
import * as S from './styles';

const CafeteriaOrderDetail = () => {
  const { ordersListDetailRequestAction } = useActions();
  const { order }: any = useTypedSelector((state) => state.Cafeteria);
  const params: any = useParams();
  const renderStatusName = (status: string) => {
    let newText: string = '';
    // eslint-disable-next-line array-callback-return
    OrderStatusEnum.map((item: any) => {
      if (item.id === status) newText = item.title;
    });
    return newText;
  };
  const statusColorHandler = (status: string, realStatus: string) => {
    switch (status) {
      case 'Delivered':
        return <S.DeliveredStatus>Delivered</S.DeliveredStatus>;
      case 'Pending':
        return <S.PendingStatus>Pending</S.PendingStatus>;
      case 'Cancelled':
        return (
          <S.CancelledStatus>
            <S.CancelledStatusTitle>Cancelled</S.CancelledStatusTitle>

            <S.TooltipContainer style={{ cursor: order?.data?.list?.cancelReasonText ? 'pointer' : 'default' }}>
              <span>
                <ReactSVG
                  src="/icons/stroke/info-circle.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `20px`);
                    svg.setAttribute('height', `20px`);
                  }}
                />
              </span>

              {order?.data?.list?.cancelReasonText && (
                <S.TooltipBox className="TooltipBox">
                  <h5>{realStatus === 'cancelled_by_user' ? 'Cancelled by Employee:' : 'Cancelled by TeaBoy:'}</h5>
                  <p>{order?.data?.list?.cancelReasonText}</p>
                </S.TooltipBox>
              )}
            </S.TooltipContainer>
          </S.CancelledStatus>
        );
      default:
        break;
    }
  };
  useEffect(() => {
    if (params?.id) ordersListDetailRequestAction(params?.id);
  }, [params]);
  return (
    <S.Container>
      <S.Head>
        <S.Title>Order Details</S.Title>

        {statusColorHandler(renderStatusName(order?.data?.list?.status), order?.data?.list?.status)}
      </S.Head>

      <S.Body>
        <S.Orders>
          <S.BoxTitle>Orders</S.BoxTitle>

          <S.OrdersContainer>
            {(order?.data?.list?.cart == null ? [{
              // optionGroups: [],
              food: { image: '/images/call-the-waiter.png', title: 'Call the Waiter' }
              // quantity: 1
            }] : order?.data?.list?.cart?.items)?.map((item: any) => {
              return (
                <S.Order style={{ gap: item?.optionGroups?.length > 0 ? '1rem' : undefined }}>
                  <S.TitleContainer>
                    <S.FoodTitle>
                      {item?.food?.image ? (
                        <S.FoodImage>
                          <img
                            src={item?.food?.image}
                            style={{ objectFit: 'cover', width: '40px', height: '40px' }}
                            alt=""
                          />
                        </S.FoodImage>
                      ) : (
                        <ReactSVG
                          src="/icons/default-food.svg"
                          beforeInjection={(svg) => {
                            svg.setAttribute('width', `40px`);
                            svg.setAttribute('height', `40px`);
                          }}
                        />
                      )}

                      <h4>
                        {item?.food?.title}

                        {item?.optionGroups?.length > 0 ? <span>{`(${item?.quantity} item)`}</span> : ''}
                      </h4>
                    </S.FoodTitle>

                    {item?.optionGroups?.length === 0 ? <S.Counter>{item?.quantity}</S.Counter> : null}
                  </S.TitleContainer>

                  <S.OptionsGroup>
                    {item?.optionGroups?.map((innerItem: any) => {
                      return (
                        <S.OptionsContainer>
                          <S.Options>
                            {innerItem?.optionItems?.map((option: any) => {
                              return (
                                <p>
                                  {`${option?.optionTitle}${option?.optionItemValues?.length > 0 ? ': ' + option?.optionItemValues?.[0]?.title : option?.booleanValue ? ': Yes' : ': No'}`}
                                </p>
                              );
                            })}
                          </S.Options>

                          <S.Counter>{innerItem?.quantity}</S.Counter>
                        </S.OptionsContainer>
                      );
                    })}
                  </S.OptionsGroup>
                </S.Order>
              );
            })}
          </S.OrdersContainer>
        </S.Orders>

        <S.InfosBox>
          <S.UserInfo>
            <S.BoxTitle>User Information</S.BoxTitle>

            <S.InfosContainer>
              <S.Infos>
                <S.InfosBox_1>
                  <S.Description>
                    <ReactSVG
                      src="/icons/stroke/frame.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('width', `22px`);
                        svg.setAttribute('height', `22px`);
                      }}
                    />
                    <p>{order?.data?.list?.user?.displayName}</p>
                  </S.Description>

                  <S.Description>
                    <ReactSVG
                      src="/icons/stroke/clock.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('width', `22px`);
                        svg.setAttribute('height', `22px`);
                      }}
                    />
                    <p>{formatDate(order?.data?.list?.localDate)}</p>
                  </S.Description>
                </S.InfosBox_1>

                <S.InfosBox_2>
                  <S.Description>
                    <ReactSVG
                      src="/icons/stroke/slider-vertical.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('width', `22px`);
                        svg.setAttribute('height', `22px`);
                      }}
                    />
                    <p>{`Floor: ${order?.data?.list?.floor?.name}`}</p>
                  </S.Description>

                  <S.Description>
                    <ReactSVG
                      src="/icons/stroke/element-2.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('width', `22px`);
                        svg.setAttribute('height', `22px`);
                      }}
                    />
                    <p>{order?.data?.list?.location}</p>
                  </S.Description>
                </S.InfosBox_2>
              </S.Infos>

              <S.Description>
                <ReactSVG
                  src="/icons/stroke/note.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `22px`);
                    svg.setAttribute('height', `22px`);
                  }}
                />
                <p>{order?.data?.list?.description ?? 'No Description'}</p>
              </S.Description>
            </S.InfosContainer>
          </S.UserInfo>

          <S.TeaBoyInfo>
            <S.BoxTitle>TeaBoy Information</S.BoxTitle>

            <S.TeaBoyBody>
              <S.Description>
                <ReactSVG
                  src="/icons/stroke/frame.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `22px`);
                    svg.setAttribute('height', `22px`);
                  }}
                />
                <p>{order?.data?.list?.teaBoy?.user?.displayName}</p>
              </S.Description>

              <S.Description>
                <ReactSVG
                  src="/icons/stroke/sms.svg"
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `22px`);
                    svg.setAttribute('height', `22px`);
                  }}
                />
                <p>{order?.data?.list?.teaBoy?.mail}</p>
              </S.Description>
            </S.TeaBoyBody>
          </S.TeaBoyInfo>
        </S.InfosBox>
      </S.Body>
    </S.Container>
  );
};
export default CafeteriaOrderDetail;
